export var AppBarEventOriginator = 'AppBar';
export var FlyoutEventOriginator = 'Flyout';
export var LaunchTileEventOriginator = 'LaunchTile';
export var SuggestedTileEventOriginator = 'SuggestedTile';
export var AppAcquisitionLinkEventOriginator = 'AppAquisitionLink';
export var AppBarEventTypes = {
    launch: 'launch',
    moreInfo: 'moreInfo',
    privacy: 'privacy',
    termsOfUse: 'termsOfUse',
    permissions: 'permissions',
    description: 'description',
    install: 'install',
    uninstall: 'uninstall',
    appAcquisitionLinkClick: 'appAcquisitionLinkClick',
    flyoutButtonHover: 'flyoutButtonHover',
    flyoutOpened: 'flyoutOpened',
    flyoutRendered: 'flyoutRendered',
    userSearch: 'userSearch',
    appTileHover: 'appTileHover',
    renderError: 'renderError',
    appBarImpression: 'appBarImpression',
};
export var AppBarEvents = {
    launch: function (data) { return ({
        originator: LaunchTileEventOriginator,
        type: AppBarEventTypes.launch,
        data: data,
    }); },
    moreInfo: function (data) { return ({
        originator: LaunchTileEventOriginator,
        type: AppBarEventTypes.moreInfo,
        data: data,
    }); },
    privacy: function (data) { return ({
        originator: SuggestedTileEventOriginator,
        type: AppBarEventTypes.privacy,
        data: data,
    }); },
    termsOfUse: function (data) { return ({
        originator: SuggestedTileEventOriginator,
        type: AppBarEventTypes.termsOfUse,
        data: data,
    }); },
    permissions: function (data) { return ({
        originator: SuggestedTileEventOriginator,
        type: AppBarEventTypes.permissions,
        data: data,
    }); },
    description: function (data) { return ({
        originator: SuggestedTileEventOriginator,
        type: AppBarEventTypes.description,
        data: data,
    }); },
    install: function (data) { return ({
        originator: SuggestedTileEventOriginator,
        type: AppBarEventTypes.install,
        data: data,
    }); },
    uninstall: function (data) { return ({
        originator: LaunchTileEventOriginator,
        type: AppBarEventTypes.uninstall,
        data: data,
    }); },
    appAcquisitionLinkClick: function (data) { return ({
        originator: AppAcquisitionLinkEventOriginator,
        type: AppBarEventTypes.appAcquisitionLinkClick,
        data: data,
    }); },
    flyoutButtonHover: function (data) { return ({
        originator: AppBarEventOriginator,
        type: AppBarEventTypes.flyoutButtonHover,
        data: data,
    }); },
    flyoutOpened: function (data) { return ({
        originator: AppBarEventOriginator,
        type: AppBarEventTypes.flyoutOpened,
        data: data,
    }); },
    flyoutRendered: function (data) { return ({
        originator: AppBarEventOriginator,
        type: AppBarEventTypes.flyoutRendered,
        data: data,
    }); },
    userSearch: function (data) { return ({
        originator: FlyoutEventOriginator,
        type: AppBarEventTypes.userSearch,
        data: data,
    }); },
    appTileHover: function (data) { return ({
        originator: LaunchTileEventOriginator,
        type: AppBarEventTypes.appTileHover,
        data: data,
    }); },
    renderError: function (data) { return ({
        originator: AppBarEventOriginator,
        type: AppBarEventTypes.renderError,
        data: data,
    }); },
    appBarImpression: function (data) { return ({
        originator: AppBarEventOriginator,
        type: AppBarEventTypes.appBarImpression,
        data: data,
    }); },
};
//# sourceMappingURL=AppBarEvents.js.map